/* unplugin-vue-components disabled */import script from "./Case.vue?vue&type=script&setup=true&lang=ts"
export * from "./Case.vue?vue&type=script&setup=true&lang=ts"

import "./Case.vue?vue&type=style&index=0&id=6e3a2fce&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3a2fce"]])

export default __exports__